import { useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Box,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { ChevronLeftRounded } from '@mui/icons-material';
import { decryptURL, findOnArray } from 'utils/functions';
import { DropsContext } from 'contexts/DropsContext';
import { logos } from 'assets/integracoes';
import { useModal } from 'components/Modals';
import Container from 'components/Container';
import Button from 'components/Button';
import Blank from 'assets/blank.png';
import Bling from './Bling';
import MercadoLivre from './MercadoLivre';
import Mercos from './Mercos';
import Shopee from './Shopee';

const Gerar = () => {
  const { hash } = useParams();
  const decrypt = hash ? decryptURL(hash) : null;
  const navigate = useNavigate();
  const defaultValues = {
    id: decrypt?.id || null,
    tipo_do_anuncio: 'normal',
    integra_access_id: decrypt?.integra_access_id || null,
  };
  const { watch, setValue } = useForm({ defaultValues });
  const { openModal, closeModal } = useModal();
  const { drops } = useContext(DropsContext);
  const id = watch('id');
  const integra_access_id = watch('integra_access_id');
  const tipo_do_anuncio = watch('tipo_do_anuncio');
  const integra_access = findOnArray(integra_access_id, drops?.IntegraAccess);
  const titulo = `${id ? 'Editar' : 'Cadastrar'} Anúncio`;
  const subtitulo =
    integra_access &&
    `${integra_access?.label ?? ''} - ${integra_access?.Conta ?? ''}`;

  const QuestionModal = ({ id }) => {
    const onSelect = (tipo) => {
      setValue('integra_access_id', id);
      setValue('tipo_do_anuncio', tipo);
      closeModal();
    };
    return (
      <>
        <DialogTitle>Selecionar Tipo de Anúncio</DialogTitle>
        <DialogContent>
          <ListItem disablePadding>
            <ListItemButton onClick={() => onSelect('normal')}>
              <ListItemText
                primary="Normal"
                secondary="O anúncio será publicado somente com um produto"
              />
            </ListItemButton>
          </ListItem>
          <Divider />
          <ListItem disablePadding>
            <ListItemButton onClick={() => onSelect('variacao')}>
              <ListItemText
                primary="Variação"
                secondary="O anúncio será publicado com variações de um produto"
              />
            </ListItemButton>
          </ListItem>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="secondary" onClick={closeModal}>
            Cancelar
          </Button>
        </DialogActions>
      </>
    );
  };

  const onSelect = ({ value, user_product_seller }) => {
    if (user_product_seller) {
      return openModal(<QuestionModal id={value} />);
    }
    return setValue('integra_access_id', value);
  };

  const Header = ({ onBack = null }) => {
    const onClick = () => {
      const cb = () =>
        id ? navigate(-1) : setValue('integra_access_id', null);
      if (onBack) {
        onBack(cb);
      } else {
        cb();
      }
    };

    return (
      <Box display="flex" mb=".5em" gap=".5em" alignItems="flex-start">
        <IconButton color="primary" size="small" onClick={onClick}>
          <ChevronLeftRounded />
        </IconButton>
        <Box>
          <Typography variant="h5">{titulo}</Typography>
          <Typography variant="subtitle1">{subtitulo}</Typography>
        </Box>
      </Box>
    );
  };

  const Loja = () => {
    return (
      <Container>
        <Header onBack={() => navigate(-1)} />
        <Typography variant="h6" textAlign="center">
          Selecione a Loja para anunciar
        </Typography>
        <List>
          {drops?.IntegraAccess?.map(
            ({ label, value, Conta, user_product_seller }, i) => {
              const nome_logo = label?.replace(/\s+/g, '');
              const logo = logos?.[nome_logo] ?? Blank;
              const imgStyle = {
                mr: 2,
                width: 100,
                height: 50,
                objectFit: 'contain',
              };
              return (
                <Box key={value}>
                  {!i && <Divider />}
                  <ListItem disablePadding>
                    <ListItemButton
                      onClick={() => onSelect({ value, user_product_seller })}
                    >
                      <Box
                        src={logo}
                        sx={imgStyle}
                        alt={label}
                        component="img"
                      />
                      <ListItemText primary={label} secondary={Conta} />
                    </ListItemButton>
                  </ListItem>
                  <Divider />
                </Box>
              );
            }
          )}
        </List>
      </Container>
    );
  };

  if (!integra_access_id) {
    return <Loja />;
  }

  const props = { id, integra_access_id, tipo_do_anuncio, Header };

  switch (integra_access?.label) {
    case 'BLING':
      return <Bling {...props} />;
    case 'MERCADO LIVRE':
      return <MercadoLivre {...props} />;
    case 'MERCOS':
      return <Mercos {...props} />;
    case 'SHOPEE':
      return <Shopee {...props} />;

    default:
      return null;
  }
};

export default Gerar;
